// extracted by mini-css-extract-plugin
module.exports = {"Empty":"HomePassings_Empty__2RBko","LoadingNew":"HomePassings_LoadingNew__2tVHV"};